import { useEffect, useState } from "react";
import { getApi } from "../../../../services/api/globalApi";

export default function Profile() {
  const [user, setUser] = useState(null);
  const getMe = async () => {
    const path = "api/users/me";
    try {
      const response = await getApi({ path });
      console.log(response);
      setUser(response?.data?.result);
      if(response?.data?.result?.role !== 'admin'){
        // window.open(`https://www.minacandles.ir`, "_self");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMe();
  }, []);
  return (
    <div className="flex gap-x-3 items-center justify-center">
      <img
        className="h-10 w-10 rounded-full border border-slate-200 bg-slate-50 object-cover p-0.5 dark:border-slate-700 dark:bg-slate-800"
        src={require("./../../../../assets/image/userIcon.png")}
        alt=""
      />
      <div className="flex flex-col justify-center text-slate-800 dark:text-slate-100">
        <p className="text-sm font-semibold leading-5">{user?.name}</p>
        <span className="text-xs text-slate-500 dark:text-slate-400">{user?.role === "admin" ? "ادمین" : user?.role === "warehouseKeeper" ? "انباردار" : user?.role}</span>
      </div>
    </div>
  );
}
